import { render, staticRenderFns } from "./CallView.vue?vue&type=template&id=4b4c09b2&scoped=true"
import script from "./CallView.vue?vue&type=script&lang=js"
export * from "./CallView.vue?vue&type=script&lang=js"
import style0 from "./CallView.vue?vue&type=style&index=0&id=4b4c09b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c09b2",
  null
  
)

export default component.exports